import React from "react";

const SureModal = ({ isOpen, onClose,onConfirm, title, actionType}) => {
  const isDeactivate = actionType === "Deactivate";
  return (
    <div
      className={`modal fade ${isOpen ? "show" : ""}`}
      tabIndex="-1"
      style={{
        display: isOpen ? "block" : "none",
      }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content" style={{ backgroundColor: "#033538" }}>
          <div className="modal-body text-center">
            <span className="fw-normal" style={{ color: "white" }}>
              Are you fine to <b>{actionType?.toLowerCase()}</b> {title} <br />
            {isDeactivate
                ? `This will immediately suspend related users and resources.`
                : `This will allow related users and resources to function again.`}
            </span>
          </div>
          <div className="modal-footer d-flex flex-column justify-content-center border-0">
            <button
              type="button"
              className="btn rounded-2 fw-medium w-50"
              onClick={onConfirm}
              style={{ backgroundColor: "#006A71", color: "#E8E8E8" }}
            >
              {actionType} {title}
            </button>
            <button
              type="button"
              className="btn rounded-2 fw-medium w-50"
              onClick={onClose}
              style={{ backgroundColor: "#FEFEFE", color: "#1E1E1E" }}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SureModal;